import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SKIP_AUTH } from '../../../core/interceptors/jwt.interceptor';
import {DocumentDto} from '@features/home/services/apartment.service';

export interface RoomType {
  id: number;
  nom: string;
  description: string | null;
}

export interface Hotel {
  id: number;
  name: string;
  address: string;
  stars: number | null;
  numberOfRooms: number | null;
  groupHotel: any | null;
  admin: any | null;
}

export interface ApiRoom {
  id: number;
  type: string | null;
  numero: number;
  prixParNuit: number;
  statut: string;
  etage: number;
  capacite: number;
  hotel: Hotel;
  hotelId: number;
  roomTypeId: number;
  roomType: RoomType;
  planTarifications: any[];
  coverImage: DocumentDto | null;
}

export interface ApiMeta {
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface ApiRoomResponse {
  content: ApiRoom[];
  meta: ApiMeta;
}

@Injectable({
  providedIn: 'root'
})
export class RoomService {
  private readonly API_URL = environment.apiUrl;


  constructor(private http: HttpClient) {}

  getRooms(startDate?: string, endDate?: string): Observable<ApiRoomResponse> {
    let params = new URLSearchParams();

    if (startDate) {
      params.append('start', startDate);
    }
    if (endDate) {
      params.append('end', endDate);
    }

    const queryString = params.toString();
    const url = `${this.API_URL}/frontOfficeController/roomsAvailable${queryString ? '?' + queryString : ''}`;

    return this.http.get<ApiRoomResponse>(url, {
      context: new HttpContext().set(SKIP_AUTH, true)
    });
  }
}
